import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import PropTypes from "prop-types";
import {
  browserPropType,
  membershipStatePropType,
  ordersPropType,
  productPropType,
  PDPContentPropType,
} from "components/propTypes";
import PDPAdminDetail from "./pdp-admin-detail.tsx";
import PDPCarousels from "../pdp/pdp-carousels";
import PDPHeader from "./pdp-header";
import PDPImagery from "../pdp/pdp-imagery";
import PDPInlineReviews from "components/source/reviews/pdp-inline-reviews";
import ProductDetails from "./product-details";
import ReservationFormWrapper from "../reservations/reservation-form-wrapper";
import sharedActions from "../../../actions/shared-actions";
import {
  isSubscriptionMember,
  isSubscriptionLens,
  isClassicLens,
  isActiveMembership,
} from "helpers/membership-helpers";
import KiffrAtbContainerComponent from "components/source/pdp/kiffr-atb-form-container";
import Constants, { RENTAL_INTENT, PDP_TYPE, PdpImageZoomModalName } from "rtr-constants";
import ViewedProductsHelpers from "helpers/viewed-products-helpers";
import { isAdmin } from "components/source/hoc/with-user-data";
import PDPShimmer from "components/source/products/pdp-shimmer";
import PdpImageZoomModal from "./pdp-image-zoom-modal";
import reviewsActions from "actions/reviews-actions";
import { logAction } from "action-logger";
import { LP } from "routes";
import AtomStickyPrimaryButton from "components/source/atoms/atom-sticky-primary-button";
import RtrImage from "../shared/rtr-image";
import {
  handleMembershipAcquisitionCTAClick,
  handleReserveAcquisitionCTAClick,
} from "../acquisition/acquisition-helpers";
import MediaQueries from "constants/mediaQueries";
import { buyNowGridAvailability } from "../../../helpers/buynow-product-availability";
import PageViewActions from "actions/logging/page-view";
import PDPBreadCrumbs from "./pdp-breadcrumbs";
import { createScrollIntoViewPixelLogger } from "analytics/element-visibility-logger";
import ProductImageRotation from "../../../helpers/product-image-rotation";
import MaternityHelper from "helpers/maternity-helper";
import { getProductImageAltText } from "helpers/product-image-helpers";
import ProductInfo from "./product-info/product-info";
import ReviewThumbNailCarousel from "../universal_pdp/reviews/review-thumbnail/review-thumbnail-carousel";
import AnchorProductAggregateRating from "components/source/products/anchor-product-aggregate-rating";
import ComingSoonPDPContent from "./coming-soon-pdp-content.jsx";
import SizeGuideModal from "./product-info/size-guide-modal.jsx";

class PDPContent extends React.Component {
  static loggingKey = "node";

  static propTypes = {
    action: PropTypes.string,
    activeOrders: ordersPropType,
    analyticsLoggingContext: PropTypes.object,
    annotationSuffix: PropTypes.string,
    availabilityFetched: PropTypes.bool,
    browser: browserPropType,
    canonicalUrl: PropTypes.string,
    cmsContent: PDPContentPropType,
    deliveryCutoffs: PropTypes.object,
    dispatch: PropTypes.func,
    displayMembershipUpsell: PropTypes.bool,
    displayReviewPhotosModal: PropTypes.func,
    displayImageZoomModal: PropTypes.func,
    displayedModal: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    errors: PropTypes.object,
    favorites: PropTypes.array,
    gridProductDrawer: PropTypes.object,
    handleWayfindCtaClick: PropTypes.func,
    hasLengths: PropTypes.bool,
    isAccessory: PropTypes.bool,
    isBuyNow: PropTypes.bool,
    isComingSoon: PropTypes.bool,
    isHeartEducationTooltipTriggered: PropTypes.bool,
    isMobileViewport: PropTypes.bool,
    isRentable: PropTypes.bool,
    isSubmitting: PropTypes.bool,
    logOpenAvailability: PropTypes.func,
    membershipBag: PropTypes.object,
    membershipPricing: PropTypes.arrayOf(PropTypes.object),
    membershipState: membershipStatePropType,
    membershipStateLoading: PropTypes.bool,
    onAddToBagFailure: PropTypes.func,
    offerBackupSize: PropTypes.bool,
    product: productPropType.isRequired,
    recommendations: PropTypes.arrayOf(PropTypes.object),
    rentalText: PropTypes.string,
    reservation: PropTypes.object,
    reviews: PropTypes.object,
    shouldLoadReviews: PropTypes.bool,
    staticProduct: PropTypes.object,
    isUnavailableToRent: PropTypes.bool,
    showPurchasePrice: PropTypes.bool,
    canRenderSplitTheBusiness: PropTypes.bool,
    smartComponentState: PropTypes.shape({}),
    userData: PropTypes.object,
    workingFilters: PropTypes.object,
    writingReview: PropTypes.bool,
    isSizeGuideModalOpen: PropTypes.bool,
  };

  static defaultProps = {
    shouldLoadReviews: true,
  };

  offsetObserver = null;

  state = {
    displayStickyCta: false,
    featureImageSelected: null,
    layout: "media-query-layout",
    dynamicSectionOffset: 0,
    isSelectedSizeAvailable: true,
    // Note: State used to render the create short list button for a 'Coming Soon' item
    showComingSoonShortList: false,
  };

  handleIsSelectedSizeAvailable = isSelectedSizeAvailable => {
    this.setState({ isSelectedSizeAvailable });
  };

  setShowComingSoonShortList = shouldShow => {
    this.setState({ showComingSoonShortList: shouldShow });
  };

  inlineReviewsRef = React.createRef(null);

  constructor(props) {
    super(props);
    this.containerRef = React.createRef();
  }

  componentDidMount() {
    const { isMobileViewport, workingFilters, dispatch, gridProductDrawer = null, membershipState } = this.props;
    // I _think_ we can get rid of this in Storefront.Next
    const stateKey = isMobileViewport
      ? Constants.partialPropsStateKeys.MOBILE_APPEND
      : Constants.partialPropsStateKeys.DESKTOP_APPEND;

    dispatch(sharedActions.fetchPartialProps(stateKey, () => {}, workingFilters, gridProductDrawer?.pdpUrl));

    window?.addEventListener("scroll", this.handleScroll);

    this.inlineReviewsScrollPositionLogger = createScrollIntoViewPixelLogger(this.inlineReviewsRef, "inline-reviews", {
      objectType: this.constructor.loggingKey,
    });

    // set dynamic layout class on mount and reapply on resize of container rather than viewport
    if (gridProductDrawer) {
      this.applyLayoutClass();
      dispatch(PageViewActions.pdpDrawerPageView());
    }

    // adding this hacky way because we need to scroll to the top when the user clicks on back button
    // of the browser but the browser seems to remember your scroll point (hence was not scrolling to the top).
    // This hack should override the behaviour
    // it's specific to mWeb only coz in mWeb we have reviews on a different page and it's not the case in desktop
    if (isMobileViewport && !gridProductDrawer) {
      window?.scrollTo(0, 0);
    }

    if (!isActiveMembership(membershipState)) {
      this.stickyTabs();
    }
  }

  componentDidUpdate(prevProps) {
    // wait for both favorites and membership bag to load before calling saveViewedProductToLocalStorage
    if (
      this.props.favorites &&
      this.props.membershipBag &&
      !this.props.membershipBag.isLoading &&
      (!prevProps.favorites?.length || prevProps.membershipBag?.isLoading)
    ) {
      this.saveViewedProductToLocalStorage();
    }

    if (this.props.membershipStateLoading === false && !isActiveMembership(this.props.membershipState)) {
      this.stickyTabs();
    }
  }

  componentWillUnmount() {
    window?.removeEventListener("scroll", this.handleScroll);
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }

    if (this.inlineReviewsScrollPositionLogger) {
      this.inlineReviewsScrollPositionLogger.disconnect();
    }

    if (this.offsetObserver) {
      this.offsetObserver.disconnect();
      this.offsetObserver = null;
    }
  }

  saveViewedProductToLocalStorage = () => {
    const { favorites, product, userData } = this.props;
    const styleName = product.id;
    const isFavorited = favorites.includes(styleName);
    const isMember = isSubscriptionMember(this.props.userData);
    const membershipBagItems = isMember ? this.props?.membershipBag?.items ?? [] : [];
    const bagStyleNames = (membershipBagItems || []).map(item => item.styleName);
    const styleIsInBag = bagStyleNames.includes(styleName);

    // only save unhearted items to viewed product list
    if (!isFavorited && isMember && !styleIsInBag) {
      ViewedProductsHelpers.addViewedProductToList(styleName, userData);
    }
  };

  renderAdminDetail() {
    if (!isAdmin(this.props.userData)) return;

    return <PDPAdminDetail id={this.props.product?.id} published={this.props.product?.published} />;
  }

  renderReservationChoices = () => {
    const { displayMembershipUpsell } = this.props;

    if (!displayMembershipUpsell) {
      return this.renderReservationFormWrapper();
    }
  };

  renderReservationFormWrapper = () => {
    const { onAddToBagFailure } = this.props;

    return (
      <ReservationFormWrapper
        action={this.props.action}
        activeOrders={this.props.activeOrders}
        analyticsLoggingContext={this.props.analyticsLoggingContext}
        browser={this.props.browser}
        canonicalUrl={this.props.canonicalUrl}
        deliveryCutoffs={this.props.deliveryCutoffs}
        dispatch={this.props.dispatch}
        displayedModal={this.props.displayedModal}
        errors={this.props.errors}
        handleWayfindCtaClick={this.props.handleWayfindCtaClick}
        hasLengths={this.props.hasLengths}
        isAccessory={this.props.isAccessory}
        isAdmin={isAdmin(this.props.userData)}
        isHomepageDrawer={false}
        isRentable={this.props.isRentable}
        isSubmitting={this.props.isSubmitting}
        logOpenAvailability={this.props.logOpenAvailability}
        membershipBag={this.props.membershipBag}
        membershipState={this.props.membershipState}
        narrow={false}
        offerBackupSize={this.props.offerBackupSize}
        product={this.props.product}
        cmsContent={this.props.cmsContent}
        onAddToBagFailure={onAddToBagFailure}
        recommendations={this.props.recommendations}
        reservation={this.props.reservation}
        canRenderSplitTheBusiness={this.props.canRenderSplitTheBusiness}
        userData={this.props.userData}
        workingFilters={this.props.workingFilters}
        isSelectedSizeAvailable={this.handleIsSelectedSizeAvailable}
      />
    );
  };

  renderAtbSection() {
    if (this.props.availabilityFetched && this.props.membershipStateLoading === false) {
      return this.renderReservationComponents();
    }
    return <PDPShimmer />;
  }

  renderReservationComponents() {
    const { canRenderSplitTheBusiness, isBuyNow, product, userData, workingFilters } = this.props;
    const defaultSku = buyNowGridAvailability(product).getDefaultSizeSelection(userData, workingFilters);
    const preSelectedSku = this.props.reservation?.primarySku?.id || defaultSku?.sku;

    if (isBuyNow) {
      return <KiffrAtbContainerComponent preSelectedSku={preSelectedSku} product={product} />;
    }

    if (canRenderSplitTheBusiness) {
      return this.renderReservationFormWrapper();
    }

    return this.renderReservationChoices();
  }

  logReadAllReviews(productId) {
    logAction({
      objectType: "node",
      action: "read_all_reviews",
      source: "review_card_module",
      style: productId,
    });

    return true;
  }

  jumpToProductDetails() {
    const { gridProductDrawer, isBuyNow } = this.props;
    let pdpUrl = gridProductDrawer?.pdpUrl;
    if (isBuyNow && gridProductDrawer?.pdpUrl) {
      pdpUrl = `${pdpUrl}?buynow=true`;

      return (
        <a className="flex items-center" href={pdpUrl}>
          <span className="semibold underline">View Full Details</span>
          <span className="reb-RightArrow"></span>
        </a>
      );
    }

    if (gridProductDrawer?.pdpUrl) {
      return (
        <a className="flex items-center" href={pdpUrl}>
          <span className="semibold underline">View Full Details</span>
          <span className="reb-RightArrow"></span>
        </a>
      );
    }

    // Would love to just jump right to the element using plain of href
    // but the sticky nav covers it if we don't use a scroll
    const scrollToElement = (event, id) => {
      event.preventDefault();
      const element = document.getElementById(id);

      const elementPosition = element.getBoundingClientRect()?.top + window.scrollY;

      window.scrollTo({
        top: elementPosition,
        behavior: "smooth",
      });

      return (
        <button className="flex items-center" onClick={event => scrollToElement(event, "product-details")}>
          <span className="semibold underline">View Product Details</span>
          <span className="reb-DownArrow"></span>
        </button>
      );
    };

    return (
      <button className="flex items-center" onClick={event => scrollToElement(event, "product-details")}>
        <span className="semibold underline">View Product Details</span>
        <span className="reb-DownArrow"></span>
      </button>
    );
  }

  handleScroll = () => {
    const triggerElement = document.querySelector(".add-to-bag-section");
    if (triggerElement) {
      const triggerPosition = triggerElement.getBoundingClientRect()?.bottom;
      const displayStickyCta = triggerPosition < 0;
      this.setState({ displayStickyCta });
    }
  };

  stickyTabs = () => {
    const { isMobileViewport } = this.props;
    if (isMobileViewport) return;

    this.offsetObserver = new MutationObserver(() => {
      const tabSection = document.querySelector('[data-test-id="pdp-add-to-bag-tabs"]');
      const dynamicSection = document.querySelector(".pdp-dynamic-section");
      const stickyHeader = document.querySelector("#nav-top-bar");

      if (tabSection && dynamicSection && stickyHeader) {
        const offset =
          tabSection.getBoundingClientRect().top -
          dynamicSection.getBoundingClientRect().top -
          stickyHeader.getBoundingClientRect().height;

        this.setState({ dynamicSectionOffset: `${-offset}px` });
        this.offsetObserver?.disconnect();
      }
    });

    this.offsetObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  };

  // Sometimes classes are applied via based on the width of the
  // container rather than the window width media queries because
  // this component is rendered as both a page and a modal
  applyLayoutClass = () => {
    const container = this.containerRef?.current;
    if (container) {
      this.setState({ layout: this.setLayoutClass(container.getBoundingClientRect()?.width) });

      //Incase screen width is changed, we need to update the layout class nbn
      this.resizeObserver = new ResizeObserver(entries => {
        for (const entry of entries) {
          const { width } = entry.contentRect;
          this.setState({ layout: this.setLayoutClass(width) });
        }
      });

      this.resizeObserver.observe(container);
    }
  };

  setLayoutClass = (width = 0) => {
    const { SMALL_TABLET_MAX_WIDTH, MOBILE_MAX_WIDTH } = MediaQueries.responsiveBreakpoints;

    // At the moment these are only used for drawer, which had a maxed layout of tablet
    if (width > SMALL_TABLET_MAX_WIDTH) return "pdp-tablet-layout";
    if (width > MOBILE_MAX_WIDTH) return "pdp-small-tablet-layout";

    return "pdp-mobile-layout";
  };

  getCurrentIntent() {
    const { canRenderSplitTheBusiness, userData } = this.props;

    if (!canRenderSplitTheBusiness) {
      return null;
    } else if (isSubscriptionLens(userData)) {
      return RENTAL_INTENT.MEMBERSHIP;
    } else if (isClassicLens(userData)) {
      return RENTAL_INTENT.RESERVE;
    } else {
      return RENTAL_INTENT.NO_INTENT;
    }
  }

  renderAcquisitionStickyButton() {
    const { canRenderSplitTheBusiness, isMobileViewport } = this.props;

    if (!isMobileViewport || !canRenderSplitTheBusiness) {
      return null;
    }

    const intent = this.getCurrentIntent();

    const ctaContent = {
      NO_INTENT: {
        buttonText: "Start renting with subscription",
        bottomButtonText: "Or, browse for special events",
        buttonOnClick: () => {
          handleMembershipAcquisitionCTAClick(PDP_TYPE.UNKNOWN_PDP_STICKY_CTA);
        },
        bottomButtonOnClick: () => {
          const triggerElement = document.querySelector(".add-to-bag-section");
          handleReserveAcquisitionCTAClick(PDP_TYPE.UNKNOWN_PDP_STICKY_CTA, this.props.handleWayfindCtaClick);
          triggerElement.scrollIntoView({ behavior: "smooth", block: "start" });
        },
      },
      RESERVE: {
        buttonText: "Choose your rental dates",
        buttonOnClick: () => {
          const triggerElement = document.querySelector(".add-to-bag-section");
          triggerElement.scrollIntoView({ behavior: "smooth", block: "start" });
          logAction({
            object_type: PDP_TYPE.RESERVE_PDP_STICKY_CTA,
            action: Constants.analytics.ACTION_TYPE.RESERVE_JUMP_TO_ATB,
          });
        },
      },
      MEMBERSHIP: {
        buttonText: "Start renting with subscription",
        buttonOnClick: () => {
          handleMembershipAcquisitionCTAClick(PDP_TYPE.MEMBERSHIP_PDP_STICKY_CTA, LP.plans);
        },
      },
    };

    const stickyCtaContent = ctaContent[intent];

    return (
      <AtomStickyPrimaryButton
        buttonText={stickyCtaContent.buttonText}
        bottomButtonText={stickyCtaContent.bottomButtonText}
        buttonOnClick={stickyCtaContent.buttonOnClick}
        bottomButtonOnClick={stickyCtaContent.bottomButtonOnClick}
        isVisible={this.state.displayStickyCta}
      />
    );
  }

  renderReviewsPreviewImage() {
    if (!this.props.gridProductDrawer) {
      return null;
    }

    const coverPhotos = this.props.reviews?.data
      ? this.props.reviews?.data.filter(review => review?.moment?.photos?.[0]?.urls?.image)
      : [];

    if (coverPhotos.length === 0) {
      return null;
    }

    const firstPhoto = coverPhotos[0]?.moment?.photos[0]?.urls.image;

    return (
      <button
        data-test-id="image-reviews-preview-button"
        onClick={this.props.displayReviewPhotosModal}
        className="review-img-preview button-img-wrapper">
        <p>How Others Wore It</p>
        <p className="universal-small--secondary">{`(${coverPhotos.length} Photos)`}</p>
        <RtrImage src={firstPhoto} loading="lazy" alt="How Others Wore It" />
        <p className="underline">View All Photos</p>
      </button>
    );
  }

  render() {
    const {
      displayMembershipUpsell,
      product,
      canRenderSplitTheBusiness,
      userData,
      isMobileViewport,
      workingFilters,
      gridProductDrawer,
    } = this.props;

    if (!product) {
      return null;
    }

    const showMaternityBumpImage = MaternityHelper.showMaternityBumpImage(userData);
    const imageRotation = ProductImageRotation(workingFilters?.canonicalSizes || [], product, showMaternityBumpImage);
    const altText = getProductImageAltText(product?.displayName, product?.designer?.displayName);
    const reviewsPreviewImage = this.renderReviewsPreviewImage();

    return (
      <div ref={this.containerRef} className="pdp-content">
        <div data-test-id="pdp-layout-container" className={`pdp-main-section ${this.state.layout}`}>
          <PDPImagery
            additionalImages={reviewsPreviewImage ? [reviewsPreviewImage] : []}
            altText={altText}
            className={"product-images"}
            isCloudZoomEnabled={false}
            images={product.images}
            imageRotation={imageRotation}
            isMobileViewport={isMobileViewport}
            onClick={(index, ref) => {
              this.setState({ featureImageSelected: { index, ref } });
              this.props.displayImageZoomModal();
            }}
            isDrawer={gridProductDrawer}
            isSelectedSizeAvailable={this.state.isSelectedSizeAvailable}
          />
          <div
            data-test-id="pdp-dynamic-section"
            className="pdp-dynamic-section"
            key="2"
            style={{ top: this.state.dynamicSectionOffset }}>
            <div key="5" className="flex flex-col gap-6 sm:gap-4">
              <PDPHeader
                analyticsLoggingContext={this.props.analyticsLoggingContext}
                annotationSuffix={this.props.annotationSuffix}
                isHeartEducationTooltipTriggered={this.props.isHeartEducationTooltipTriggered}
                isMembershipUpsellView={this.props.displayMembershipUpsell}
                isRentable={this.props.isRentable}
                canRenderSplitTheBusiness={this.props.canRenderSplitTheBusiness}
                isRetailOnly={
                  (displayMembershipUpsell && !canRenderSplitTheBusiness) ||
                  (canRenderSplitTheBusiness && !isClassicLens(this.props.userData))
                }
                membershipPricing={this.props.membershipPricing}
                product={this.props.product}
                redirectUrl={gridProductDrawer?.pdpUrl}
                rentalText={this.props.rentalText}
                reviews={this.props.reviews}
                showPurchasePrice={this.props.showPurchasePrice}
                showComingSoonShortList={this.state.showComingSoonShortList}
              />

              {!this.props.isComingSoon && this.props.reviews?.count ? (
                <>
                  <AnchorProductAggregateRating
                    className="block"
                    productId={product?.id}
                    reviews={{
                      count: this.props.reviews?.count,
                      averageRating: this.props.reviews?.averageRating,
                    }}
                    redirectUrl={gridProductDrawer?.pdpUrl}
                  />

                  {!isMobileViewport && (
                    <ReviewThumbNailCarousel
                      productId={product?.id}
                      averageRating={this.props.reviews?.averageRating}
                    />
                  )}
                </>
              ) : null}

              {this.renderAdminDetail()}

              {this.props.isComingSoon && (
                <>
                  <ComingSoonPDPContent
                    analyticsLoggingContext={this.props.analyticsLoggingContext}
                    isHeartEducationTooltipTriggered={this.props.isHeartEducationTooltipTriggered}
                    location={
                      this.props.gridProductDrawer
                        ? Constants.analytics.ACTION_LOCATIONS.DRAWER
                        : Constants.analytics.ACTION_LOCATIONS.PDP
                    }
                    product={product}
                    setShowComingSoonShortList={this.setShowComingSoonShortList}
                  />
                  <hr className="border-lighterGray" />
                </>
              )}
              {!isMobileViewport && this.jumpToProductDetails()}

              {/* Add to bag will not render on COMING SOON */}
              {!this.props.isComingSoon && (
                <div
                  data-test-id="add-to-bag-section"
                  className={`add-to-bag-section ${
                    !isActiveMembership(this.props.membershipState) ? "" : "border-b border-lighterGray"
                  }`}>
                  {this.renderAtbSection()}
                </div>
              )}

              {isMobileViewport && <div data-test-id="mobile-reviews-partial-anchor" id="reviews-partial" />}
            </div>
          </div>
        </div>
        {!isMobileViewport && (
          <ProductDetails
            showOptionalDetails={this.props.isBuyNow}
            isMobileViewport={isMobileViewport}
            imageRotation={imageRotation}
            images={product?.images}
            displayName={product?.displayName}
            designerDisplayName={product?.designer?.displayName}
            productId={product?.id}
            fitNotes={product?.fitNotes}
            stylistNotes={product?.stylistNotes}
            productDetails={product?.productDetails}
          />
        )}

        <ProductInfo
          imageRotation={imageRotation}
          images={product?.images}
          displayName={product?.displayName}
          designerDisplayName={product?.designer?.displayName}
          productId={product?.id}
          fitNotes={product?.fitNotes}
          stylistNotes={product?.stylistNotes}
          productDetails={product?.productDetails}
          logReadAllReviews={this.logReadAllReviews}
        />

        <SizeGuideModal
          isOpen={this.props.isSizeGuideModalOpen}
          designerName={product?.designer?.displayName}
          designerNotes={this.props.staticProduct?.fitNotes}
        />

        {gridProductDrawer && this.props.staticProduct && (
          <PDPCarousels
            key="1"
            annotationSuffix={this.props.annotationSuffix}
            dispatch={this.props.dispatch}
            isRentable={this.props.isRentable}
            isAccessory={this.props.isAccessory}
            product={this.props.product}
            pdpCarouselList={this.props.product?.pdpCarouselList}
            isUnavailableToRent={this.props.isUnavailableToRent}
            isUPDP={false}
            staticProduct={this.props.staticProduct}
          />
        )}

        {!gridProductDrawer && (
          <PDPCarousels
            key="1"
            annotationSuffix={this.props.annotationSuffix}
            dispatch={this.props.dispatch}
            isRentable={this.props.isRentable}
            isAccessory={this.props.isAccessory}
            product={this.props.product}
            pdpCarouselList={this.props.product?.pdpCarouselList}
            isUnavailableToRent={this.props.isUnavailableToRent}
            isUPDP={false}
          />
        )}

        {!isMobileViewport && <div data-test-id="desktop-reviews-partial-anchor" id="reviews-partial" />}
        {!isMobileViewport && (
          <PDPInlineReviews
            dispatch={this.props.dispatch}
            key="0"
            ref={this.inlineReviewsRef}
            product={this.props.product}
            reviews={this.props.reviews}
            shouldLoadReviews={this.props.shouldLoadReviews}
            workingFilters={this.props.workingFilters}
            writingReview={this.props.writingReview}
          />
        )}

        {this.renderAcquisitionStickyButton()}

        <PdpImageZoomModal
          altText={altText}
          images={product.images}
          imageRotation={imageRotation}
          isMobileViewport={isMobileViewport}
          openingElement={this.state.featureImageSelected}
        />

        <PDPBreadCrumbs productDrawer={!!this.props.gridProductDrawer} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isBuyNow: state.isBuyNow,
    isComingSoon: state?.staticProduct?.isComingSoon || state?.drawerStaticProduct?.isComingSoon || false,
    displayedModal: state.displayedModal,
    gridProductDrawer: state.gridProductDrawer,
    reviewsThumbnailPhotos: state.reviewsThumbnailPhotos?.moments,
    staticProduct: state?.staticProduct || state?.drawerStaticProduct,
    membershipStateLoading: state.membershipStateLoading,
    isSizeGuideModalOpen: state?.pdp?.sizeGuideModalOpen || false,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    displayReviewPhotosModal: () => {
      dispatch(sharedActions.displayModal("REVIEW_PHOTOS"));
    },
    displayImageZoomModal: () => {
      dispatch(sharedActions.displayModal(PdpImageZoomModalName));
    },

    dismissModal: () => {
      dispatch(sharedActions.displayModal(false));
    },
    openSpecificReviewPhoto: i => {
      dispatch(reviewsActions.openSpecificReviewPhoto(i));
    },
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(PDPContent);
